import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { BAND_ADHERENCE_ENABLED_FLAG_KEY, FeatureFlagService } from './feature-flag.service';

/**
 * Gates the CMI Adherence (`/pricing/adherence`) + Impact (`/pricing/impact`)
 * tabs behind the `band_adherence` Amplitude flag, falling back to the
 * `bandAdherence` environment flag when Amplitude has no variant for the caller
 * (or Amplitude is disabled for the env). Mirrors `reviewBandsEnabledGuard` so
 * the tabs roll out per-tenant/per-user via Amplitude without a redeploy;
 * deployed envs fall through to `false` until Amplitude reports `'on'`. The
 * backend endpoints are not separately gated, so flipping this flag is all it
 * takes. Defense-in-depth against deep links; the sidebar entries also check the
 * flag.
 */
export const bandAdherenceEnabledGuard: CanActivateFn = async () => {
  const flags = inject(FeatureFlagService);
  const router = inject(Router);
  await flags.ready();
  return (
    flags.isEnabledWithFallback(
      BAND_ADHERENCE_ENABLED_FLAG_KEY,
      environment.features.bandAdherence
    ) || router.createUrlTree(['/pricing'])
  );
};
